export const pricePlansFeatureKey = 'pricePlans';
